import React, { memo } from 'react'
import PropTypes from 'prop-types'

import { FastField } from 'formik'

import TextField from './components/TextField'

const FormTextField = props => {
	const { layout = 'transparent', label = '', required = false } = props
	return (
		<FastField key={`${layout}_${label}_${required}`} {...props}>
			{({ field, meta: { touched, error } }) => {
				const errorText = touched ? error : ''

				return (
					<TextField
						{...props}
						layout={layout}
						label={label}
						required={required}
						{...field}
						error={!!errorText && touched}
						helperText={errorText}
					/>
				)
			}}
		</FastField>
	)
}

FormTextField.propTypes = {
	name: PropTypes.string.isRequired,
	// eslint-disable-next-line react/no-unused-prop-types
	usePaperColors: PropTypes.bool,
	label: PropTypes.string,
	required: PropTypes.bool,
	layout: PropTypes.string,
}

export default memo(FormTextField)
